import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { Checkbox } from "azure-devops-ui/Checkbox";

const firstCheckbox = new ObservableValue<boolean>(false);
const secondCheckbox = new ObservableValue<boolean>(false);
const thirdCheckbox = new ObservableValue<boolean>(false);

export default class CheckboxesStackedExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="rhythm-vertical-8 flex-column">
                <Checkbox
                    onChange={(event, checked) => (firstCheckbox.value = checked)}
                    checked={firstCheckbox}
                    label="Basic checkbox 1"
                />
                <Checkbox
                    onChange={(event, checked) => (secondCheckbox.value = checked)}
                    checked={secondCheckbox}
                    label="Basic checkbox 2"
                />
                <Checkbox
                    onChange={(event, checked) => (thirdCheckbox.value = checked)}
                    checked={thirdCheckbox}
                    label="Basic checkbox 3"
                />
            </div>
        );
    }
}
